export default {"src":"/_next/static/media/google.a9d5d5bf.svg","height":512,"width":512};